import type { ComponentProps } from 'react';
import Balancer from 'react-wrap-balancer';

import { cn } from '~lib/utils/style';

import { Typography, type TypographyVariant } from '~ui/base/typography';

interface BalancedMainHeadingProps extends ComponentProps<'h1'> {
  variant?: TypographyVariant;
}

// Copied from dataset-search-frontend. Page-level heading with
// `react-wrap-balancer`. See DESIGN.md §3.
function BalancedMainHeading({
  variant = 'headline-lg',
  children,
  className,
  ...props
}: BalancedMainHeadingProps) {
  return (
    <Typography as="h1" variant={variant} className={cn(className)} {...props}>
      <Balancer>{children}</Balancer>
    </Typography>
  );
}

export { BalancedMainHeading };
